import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from 'react-redux';
import { useParams } from "react-router-dom";
import { listNotificationsByCategoryAction, loadingToggleAction } from "../../../store/actions/NotificationAction";
import NotificationListItem from "./NotificationListItem";
import NotificationPagination from './NotificationListItem';
import { Link } from "react-router-dom";
import {
  Dropdown
} from 'react-bootstrap'
import { useTranslation } from "react-i18next";


export const NotificationsList = (props) => {
    const { category } = useParams();

    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [filterResults, setFilterResults] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    let max = 10;

    let totalPages = props.notifications.length > max ? (props.notifications.length % max === 0 ? props.notifications.length / max : parseInt(props.notifications.length / max) + 1)  : 1;

    const loadPageData = () => {
        let start = (currentPage - 1) * max;
        setData(props.notifications.slice(start, start+max));
    }

    const changePage = (page) => {
        setCurrentPage(page);
        loadPageData();
    }
    const {t}= useTranslation()


    
    useEffect(() => {
        dispatch(loadingToggleAction());
        dispatch(listNotificationsByCategoryAction(category));
        loadPageData();
    }, []); 

    const chackbox = document.querySelectorAll(".patient_checkbox input");
    const motherChackBox = document.querySelector(".patient_strg input");
    const chackboxFun = (type) => {
        for (let i = 0; i < chackbox.length; i++) {
            const element = chackbox[i];
            if (type === "all") {
                if (motherChackBox.checked) {
                element.checked = true;
                } else {
                element.checked = false;
                }
            } else {
                if (!element.checked) {
                motherChackBox.checked = false;
                break;
                } else {
                motherChackBox.checked = true;
                }
            }
        }
    };

    const filterNoConv = () => {
    }

    return (
        <>
            { props.showLoading && 
            <div id="preloader">
                <div className="sk-three-bounce">
                    <div className="sk-child sk-bounce1"></div>
                    <div className="sk-child sk-bounce2"></div>
                    <div className="sk-child sk-bounce3"></div>
                </div>
            </div> }

            { !props.showLoading &&
            <>
            <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
                <div className="mr-auto d-none d-lg-block">
                    <h3>{category}</h3>
                </div>
                <div className="input-group search-area ml-auto d-inline-flex mr-3">
                    <input
                    type="text"
                    className="form-control"
                    placeholder={t("dashboard.search")}
                    />
                    <div className="input-group-append">
                    <button type="button" className="input-group-text">
                        <i className="flaticon-381-search-2" />
                    </button>
                    </div>
                </div>
                {/*<Link to="#" className="settings-icon">
                    <i className="flaticon-381-settings-2 mr-0" />
                </Link>*/}
                <Dropdown>
                  <Dropdown.Toggle>
                    <i className="flaticon-381-settings-2 mr-0" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className='dropdown-menu-right'>
                    <h5 className='dropdown-header'>{t("common.filter-by")}</h5>
                    <Dropdown.Item onClick={(e) => filterNoConv()}>{t("common.unregulated")}</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
            </div>

            <div className="row">
                <div className="col-xl-12">
                    <div className="table-responsive">
                        <div id="patient_list" className="dataTables_wrapper no-footer">

                            <table
                                id="example5"
                                className="table table-striped patient-list mb-4 dataTablesCard fs-14 dataTable no-footer"
                                role="grid"
                                aria-describedby="example5_info">

                                <thead>
                                    <tr role="row">
                                        <th
                                            className="patient_strg"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-sort="ascending"
                                            style={{ width: 24 }}
                                        >
                                            <div className="checkbox text-right align-self-center">
                                                <div className="custom-control custom-checkbox ">
                                                <input
                                                    type="checkbox"
                                                    onClick={() => chackboxFun("all")}
                                                    className="custom-control-input"
                                                    id="checkAll"
                                                    required
                                                />
                                                <label
                                                    className="custom-control-label"
                                                    htmlFor="checkAll"
                                                />
                                                </div>
                                            </div>
                                        </th>
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label="Patient ID: activate to sort column ascending"
                                            style={{ width: 150 }}
                                        >
                                            {t("common.transmitted")}
                                        </th>
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label="Date Check In: activate to sort column ascending"
                                            style={{ width: 113 }}
                                        >
                                            Message
                                        </th>
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label="Patient Name: activate to sort column ascending"
                                            style={{ width: 108 }}
                                        >
                                            Date
                                        </th>
                                        <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example5"
                                            rowSpan={1}
                                            colSpan={1}
                                            aria-label=": activate to sort column ascending"
                                            style={{ width: 24 }}
                                        >Action</th>

                                    </tr>
                                </thead>

                                <tbody>
                                    {(props.notifications?.slice((currentPage - 1) * max, ((currentPage - 1) * max) +max)).map(notification => {
                                        return <NotificationListItem key={notification.id} notification={notification} history={props.history}/>
                                    })}
                                </tbody>

                            </table>
                           <NotificationPagination totalData={props.notifications.length} total={totalPages} currentPage={currentPage} switchPage={changePage} max={max} />
                        </div>
                    </div>
                </div>
            </div>
            </>
            }
        </> 
    )
};

const mapStateToProps = (state) => {
    return {
        notifications: state.notification.notifications,
        showLoading: state.notification.showLoading,
    };
};

export default connect(mapStateToProps)(NotificationsList);